import { Http } from 'packages/workspace/modules/prelude/http';
import type { HttpModel } from 'packages/workspace/modules/prelude/http/http';
import { UseMutationResult, useMutation } from 'react-query';
import type { IBug } from '../models/bug';

export function useAddBug(): UseMutationResult<IBug, unknown, HttpModel.IRequestPayload, unknown> {
  return useMutation((createData: HttpModel.IRequestPayload) => Http.Request<IBug>('POST', '/workspaces/api/v1/bug-reports.create', createData));
}
